import httpUtils from '../../utils/HttpUtils'

class ShopService {

  //获取店铺列表信息
  async list(sort = '',categoryId = '',keyword = '', pageNo = 1) {
    let result = null;
    try {
      let sortOrder = 'desc';
      result = await httpUtils.post('/mall/shop/list', {sort,categoryId,sortOrder,keyword, pageNo})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }


  //获取店铺详情信息
  async detail(id = '') {
    let result = null
    try {
      result = await httpUtils.get('/mall/shop/detail',{id})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

  //获取店铺促销活动列表信息
  async promotionList(shopId = '',activityId = '') {
    let result = null
    try {
      result = await httpUtils.get('/mall/shop/promotion/list',{shopId,activityId})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

  //保存店铺留言
  async leaveMessageSave(dealerShopLeaveMessage = {}) {
    let result = null
    try {
      result = await httpUtils.get('/mall/shop/leaveMessage/save',dealerShopLeaveMessage)
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

  //保存店铺留言列表
  async leaveMessageList(shopId = '') {
    let result = null
    try {
      result = await httpUtils.get('/mall/shop/leaveMessage/list',{shopId})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }
}
export default new ShopService()
